import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

const formatToSelect = list =>
  list.map(({ id, fullName, title }) => ({
    value: id,
    label: fullName || title,
  }))

export const useLoadData = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Clinic'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/clinics.json`)
      if (!res.ok) {
        throw new Error(`Error fetching clinic: ${res.statusText}`)
      }
      return res.json()
    },
  })

  const clinic = data
  const rooms = useMemo(() => formatToSelect(data?.rooms || []), [data])
  const doctors = useMemo(() => formatToSelect(data?.doctors || []), [data])

  return {
    loading: isLoading,
    error: isError,
    clinic,
    rooms,
    doctors,
  }
}
